import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';

import { WaitPlugin } from '@/plugins/WaitPlugin';
import { ErrorLogPlugin } from '@/plugins/ErrorLogPlugin';
import { RootElementAttrsPlugin } from '@/plugins/RootElementAttrsPlugin';
import { MetrixPlugin } from '@/plugins/MetrixPlugin';
import { EnrichVarsPlugin } from '@/plugins/EnrichVarsPlugin';

Vue.use(WaitPlugin);
Vue.use(ErrorLogPlugin);
Vue.use(MetrixPlugin);
Vue.use(EnrichVarsPlugin);
Vue.use(VueCompositionAPI);
Vue.use(RootElementAttrsPlugin);
